__turbopack_context__.v({
  "card-edit-input-container": "UrlFields-module-scss-module__85IgEa__card-edit-input-container",
  "card-edit-select": "UrlFields-module-scss-module__85IgEa__card-edit-select",
  "card-edit-select-container": "UrlFields-module-scss-module__85IgEa__card-edit-select-container",
  "phone-number-input": "UrlFields-module-scss-module__85IgEa__phone-number-input",
  "suggestions-section-container": "UrlFields-module-scss-module__85IgEa__suggestions-section-container",
  "type-label": "UrlFields-module-scss-module__85IgEa__type-label",
  "url-preview": "UrlFields-module-scss-module__85IgEa__url-preview",
  "url-preview-content-container": "UrlFields-module-scss-module__85IgEa__url-preview-content-container",
  "url-preview-icon": "UrlFields-module-scss-module__85IgEa__url-preview-icon",
  "value-input-container": "UrlFields-module-scss-module__85IgEa__value-input-container",
});
